module.exports = __webpack_public_path__ + "img/ancillary.95a9769f.jpg";